// const imageUrl = 'https://api.totalhomecrm.com/images/';

// direct access for S3 Bucket //
const imageUrl = 'https://total-home-app-images.s3.ap-south-1.amazonaws.com/';

export default imageUrl;